import type {
  AuthResponse,
  EmailLoginRequest,
  EmailRegisterRequest,
  LinkGoogleRequest,
  UpdateProfileRequest,
  UserProfileResponse,
} from '@/types/auth'
import { apiClient } from './client'

export const authApi = {
  authenticateWithGoogle(idToken: string): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/api/GoogleAuth/Authenticate', {
      IdToken: idToken,
    })
  },

  registerWithEmail(request: EmailRegisterRequest): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/api/auth/register', request)
  },

  loginWithEmail(request: EmailLoginRequest): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/api/auth/login', request)
  },

  linkGoogle(request: LinkGoogleRequest): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/api/auth/link-google', request)
  },

  getProfile(token: string): Promise<UserProfileResponse> {
    return apiClient.get<UserProfileResponse>('/api/auth/profile', undefined, {
      headers: { Authorization: `Bearer ${token}` },
    })
  },

  updateProfile(token: string, request: UpdateProfileRequest): Promise<UserProfileResponse> {
    return apiClient.put<UserProfileResponse>('/api/auth/profile', request, {
      headers: { Authorization: `Bearer ${token}` },
    })
  },
}
